'use client';
import React from "react";
import { Building2, Wrench, Factory, Ruler, Zap, HardHat, ShieldCheck, Package, SlidersHorizontal } from 'lucide-react'; // Importing Lucide icons, added SlidersHorizontal

export const Services: React.FC = () => {
  // Data for the service cards, including their content, icon, and description
  const servicesCardsData = [
    {
      icon: Factory, // Appropriate icon for Oil & Gas
      title: "Oil & Gas",
      description: "Providing specialized equipment and solutions for the oil and gas industry.",
    },
    {
      icon: SlidersHorizontal, // Appropriate icon for Flow Control
      title: "Flow Control Solutions",
      description: "Delivering advanced flow control systems for various industrial applications.",
    },
    {
      icon: Wrench, // Appropriate icon for Industrial Process Equipment
      title: "Industrial Process Equipment",
      description: "Supplying robust and efficient equipment for industrial processes.",
    },
    {
      icon: Ruler, // Appropriate icon for Instrumentation & Measurement
      title: "Instrumentation & Measurement",
      description: "Offering precise instrumentation and measurement tools for accurate operations.",
    },
    {
      icon: Zap, // Appropriate icon for Electrical Products
      title: "Electrical Products",
      description: "Providing a wide range of electrical products and components.",
    },
    {
      icon: Building2, // Changed to Building2 for a more general mechanical feel
      title: "Mechanical & Electromechanical Components",
      description: "Supplying essential mechanical and electromechanical components for diverse systems.",
    },
    {
      icon: HardHat, // Appropriate icon for Heavy Construction Equipment
      title: "Heavy Construction Equipment",
      description: "Delivering heavy machinery and equipment for large-scale construction projects.",
    },
    {
      icon: ShieldCheck, // Appropriate icon for Firefighting & Safety Systems
      title: "Firefighting & Safety Systems",
      description: "Implementing comprehensive firefighting and safety systems for protection.",
    },
    {
      icon: Package, // Appropriate icon for General Order Supplies
      title: "General Order Supplies",
      description: "Offering a broad catalog of general order supplies for various needs.",
    },
  ];

  return (
    // Main section with white background and dark text
    <section className="bg-white text-gray-900 py-8 md:py-12 lg:py-16 overflow-hidden min-h-[100vh] flex flex-col items-center">
      <div className="container mx-auto px-4 text-left relative z-10 max-w-7xl">
        {/* Header section */}
        {/* <p className="text-orange-500 text-base font-semibold mb-2">See all Service</p> */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-medium leading-tight md:max-w-xl">
            Our services
          </h2>
          {/* <p className="text-lg sm:text-xl text-gray-600 mt-4 md:mt-0 md:max-w-md">
            At Mason, we offer end-to-end building services that cover every phase of your project – from initial planning and design to final construction and handover.
          </p> */}
        </div>

        {/* Services Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10 mt-8">
          {servicesCardsData.map((service, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col justify-start items-start"
            >
              {/* Icon */}
              <div className="mb-4 p-3 rounded-full bg-orange-100 text-orange-500">
                <service.icon size={28} strokeWidth={2} />
              </div>
              {/* Title */}
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
                {service.title}
              </h3>
              {/* Description */}
              <p className="text-gray-600 text-base mb-4 flex-grow">
                {service.description}
              </p>
              
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
